import TasksView_Settings from "../../../core/settings/settings"
import {TableRenderMode} from "../../@const"
import {TasksViewAppSettings} from "../../../core/@types"
import table_convertSettings from "./converter/convert"

const HIGH_PERFORMANCE_ROW_HEIGHT = 38 + 1 // 1px for border
const HIGH_PERFORMANCE_EXTENDED_ROW_HEIGHT = 56 + 1 // 1px for border
export const HIGH_PERFORMANCE_THRESHOLD = 1000

export default class Table_Settings extends TasksView_Settings {

    public lineHeight                       : number    = 44
    public headerHeight                     : number    = 49

    public highPerformanceRowHeight         : number    = HIGH_PERFORMANCE_ROW_HEIGHT
    public highPerformanceRowExtendedHeight : number    = HIGH_PERFORMANCE_EXTENDED_ROW_HEIGHT

    private _renderMode               : TableRenderMode = TableRenderMode.STANDARD    // table render mode regular or performance = virtualized

    get renderMode(): TableRenderMode {
        // console.log("force performance mode")
        return TableRenderMode.PERFORMANCE
        // return this._renderMode
    }

    set renderMode(value: TableRenderMode) {
        this._renderMode = value
    }

    normalizeSettingsConfig(settingsConfig?: TasksViewAppSettings): TasksViewAppSettings {
        let result = settingsConfig || {}

        // 1. Version fix & convert
        result = table_convertSettings(result)

        // 2. Normalize ????
        // normalization is handled separately in isConfigChanged() and configToSave()
        // so it's likely unnecessary to call it here
        // result = this.normalizeConfig2(result)

        return result
    }
}